import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, UrlTree } from '@angular/router';
import { catchError, map, Observable, of } from 'rxjs';
import { AuthService } from '../../modules/auth/services/auth.service';

export const AuthGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot
): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree => {
  const router: Router = inject(Router);
  const authService: AuthService = inject(AuthService);

  const checkLogin = (route: ActivatedRouteSnapshot): boolean => {
    // Get the roles required from the route.
    const requiredRoles = route.data['authorities'];

    // Allow the user to to proceed if no additional roles are required to access the route.
    if (!(requiredRoles instanceof Array) || requiredRoles.length === 0) {
      return true;
    }

    // Allow the user to proceed if all the required roles are present.
    //return requiredRoles.every((role) => authService.getLoggedUser.roles.includes(role));
    return true;
  };

  return authService.isAuthenticated().pipe(
    map(isAuthenticated => {
      if (isAuthenticated) {
        return checkLogin(route);
      } else {
        router.navigate(['/auth/login']); //TODO redirect to login with next redirect ref
        return false;
      }
    }),
    catchError(() => {
      router.navigate(['/auth/login']); //TODO redirect to login with next redirect ref
      return of(false);
    })
  );
};
